import { useQuery } from '@tanstack/react-query';
import Queries from '../Common/Queries';
import { getHomePageProducts } from '../Pages/Services/homeService';

export default function useGetHomePageProducts() {
    return useQuery({
        queryKey: [Queries.GET_HOME_PAGE_PRODUCTS],
        queryFn: () => getHomePageProducts(),
        select: (data) => data.data || [],
        meta: { errorMessage: 'Failed to fetch home page products  ' },
    });
}
